import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const attachedTaskAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'attachedTaskAPI',
    endpoints: (builder) => ({

        getAttachTask: builder.query({
            query: ({ projectId, taskId }) => ({
                url: `/AttachedTask/GetAttachTask?ProjectId=${projectId}&TaskId=${taskId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAttachedTaskByTaskId: builder.query({
            query: ( taskId ) => ({
                url: `/AttachedTask/GetAttachedTaskByTaskId?TaskId=${taskId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addAttachedTask: builder.mutation({
            query: (data) => ({
                url: `AttachedTask/AddAttachedTasks`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    })

})

export const {
    useLazyGetAttachTaskQuery,
    useAddAttachedTaskMutation,
    useLazyGetAttachedTaskByTaskIdQuery,
} = attachedTaskAPI;

export default attachedTaskAPI;